import React from 'react';
import { useParams } from 'react-router-dom';
import { StructuredContentPage } from '../components/content/StructuredContentPage';
import { NotFoundPage } from './NotFoundPage';
import { SEO } from '../components/seo/SEO';
import { useLanguage } from '../context/LanguageContext';
import { servicesDe } from '../data/services-de';
import { servicesEn } from '../data/services-en';

export const ServiceContentPage: React.FC = () => {
  const { serviceId } = useParams<{ serviceId: string }>();
  const { language } = useLanguage();

  const services = language === 'en' ? servicesEn : servicesDe;
  const entry = serviceId ? services[serviceId] : undefined;

  if (!entry) {
    return <NotFoundPage />;
  }

  return (
    <>
      <SEO
        title={entry.title}
        description={entry.subtitle}
        canonical={`/services/${serviceId}`}
        schema={{
          '@context': 'https://schema.org',
          '@type': 'Service',
          name: entry.title,
          description: entry.subtitle,
          provider: {
            '@type': 'Organization',
            name: 'Integrova AI',
          },
        }}
      />
      <StructuredContentPage
        eyebrow={language === 'en' ? 'Solution' : 'Lösung'}
        title={entry.title}
        subtitle={entry.subtitle}
        heroImage={entry.heroImage}
        contextDesc={entry.contextDesc}
        operationalReality={entry.operationalReality}
        deliverables={entry.deliverables}
        architectureBlueprint={entry.architectureBlueprint}
        capabilities={entry.capabilities}
        techStack={entry.techStack}
        timeline={entry.timeline}
        riskCompliance={entry.riskCompliance}
        enablement={entry.enablement}
        detailedEnablement={entry.detailedEnablement}
        benefits={entry.benefits}
        realityTag={entry.realityTag}
        deliverablesTag={entry.deliverablesTag}
        riskTag={entry.riskTag}
        benefitsTag={entry.benefitsTag}
        nextSteps={entry.nextSteps}
        capabilitiesTitle={entry.capabilitiesTitle}
        deliverablesTitle={entry.deliverablesTitle}
      />
    </>
  );
};
